import {Leva} from "leva";
import React, {useState} from "react";
import clsx from "clsx";

export default function VisualizerToolbar({showSelectors, productConfigs, _onShowSelectorsChange, _onProductConfigsChange}) {
    const [hideCustomization, setHideCustomization] = useState(true);
    const _onToggleVisualizerCustomization = () => {
        setHideCustomization(hideCustomization ? false : true);
    };

    return <>
        <div id="vz_toolbar" className="app-toolbar bg-light">
            <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                <div className="d-flex align-items-center gap-2 gap-lg-3 me-3 ">
                    <button
                        className={clsx(
                            "btn btn-sm rounded-1 lh-1 py-4",
                            {'btn-secondary': hideCustomization},
                            {'btn-dark': !hideCustomization}
                        )}
                        onClick={_onToggleVisualizerCustomization}
                    >
                        <i className="ki-duotone ki-setting-4 fs-4 me-1"></i> Customize
                    </button>
                    <div className="form-check form-switch form-switch-sm form-check-custom form-check-solid">
                        <input className="form-check-input" type="checkbox" name="showSelectors" checked={showSelectors} onChange={_onShowSelectorsChange} />
                        <label className="form-check-label">Show Selectors</label>
                    </div>
                </div>
                <div className="d-flex align-items-center gap-2 gap-lg-3">
                    {
                        productConfigs.active.length > 0 &&
                        <div className="d-flex align-items-center">
                            <div
                                className={clsx(
                                    "position-relative btn btn-color-gray-800 btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px",
                                    {'btn-light-primary': productConfigs.show},
                                )}
                                onClick={() => {
                                    _onProductConfigsChange('show', false)
                                }}
                            >
                                {/*<i className="ki-duotone ki-gear fs-2x">*/}
                                {/*    <i className="path1"></i>*/}
                                {/*    <i className="path2"></i>*/}
                                {/*</i>*/}
                                <i className="ki-duotone ki-color-swatch fs-2x">
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                    <span className="path3"></span>
                                    <span className="path4"></span>
                                    <span className="path5"></span>
                                    <span className="path6"></span>
                                    <span className="path7"></span>
                                    <span className="path8"></span>
                                    <span className="path9"></span>
                                    <span className="path10"></span>
                                    <span className="path11"></span>
                                    <span className="path12"></span>
                                    <span className="path13"></span>
                                    <span className="path14"></span>
                                    <span className="path15"></span>
                                    <span className="path16"></span>
                                    <span className="path17"></span>
                                    <span className="path18"></span>
                                    <span className="path19"></span>
                                    <span className="path20"></span>
                                    <span className="path21"></span>
                                </i>
                                {
                                    productConfigs.notification &&
                                    <span className="bullet bullet-dot bg-danger h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink"></span>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
        <div id="leva__root">
            <Leva hidden={hideCustomization} />
        </div>
    </>
}